import { toast } from 'sonner'

import { FirebaseFields } from 'src/types'

import firestoreService from 'src/api/service'
import localService from 'src/api/localeService'

import {
  AddMaintenanceProps,
  DeleteMaintenanceProps,
  FullMaintenanceProps,
  UpdateMaintenanceProps,
} from 'src/api/Maintenance/types'

export async function addMaintenanceTrackingHistory(
  { payload, name }: AddMaintenanceProps,
  goToCars: () => void,
): Promise<void> {
  if (!name) {
    toast(localService.translation.fireBaseErrors.mustHaveCar.mustHave, {
      description: localService.translation.fireBaseErrors.mustHaveCar.suggest,
      action: {
        label: localService.translation.fireBaseErrors.mustHaveCar.okay,
        onClick: goToCars,
      },
    })

    throw Error(localService.translation.fireBaseErrors.mustHaveCar.mustHave)
  }

  await firestoreService.addDataToCollection(
    FirebaseFields.HISTORY_OF_MAINTENANCE,
    payload,
    name,
  )
}

export async function getAllMaintenanceHistory(
  carName?: string,
): Promise<FullMaintenanceProps[]> {
  if (!carName) {
    throw Error(localService.translation.fireBaseErrors.mustHaveCar.mustHave)
  }

  const maintenanceHistory =
    await firestoreService.getCollectionData<FullMaintenanceProps>(
      FirebaseFields.HISTORY_OF_MAINTENANCE,
      carName,
    )

  return maintenanceHistory
}

export async function updateMaintenanceTrackingHistory({
  payload,
  id,
  name,
}: UpdateMaintenanceProps): Promise<void> {
  await firestoreService.updateDataInCollection(
    FirebaseFields.HISTORY_OF_MAINTENANCE,
    id,
    payload,
    name,
  )
}

export async function deleteMaintenanceHistoryItem({
  id,
  name,
}: DeleteMaintenanceProps): Promise<void> {
  await firestoreService.deleteDataFromCollection(
    FirebaseFields.HISTORY_OF_MAINTENANCE,
    id,
    name,
  )
}
